<template>
  <v-form class="bill__form" ref="form">
    <div class="bill__block">
      <div class='text-h6 font-weight-regular'>Thông tin thanh toán</div>
      <div class="bill__field pt-2">
        <div class="bill__label"> Tổng Tiền:</div>
        <div class="bill__input font-weight-bold">{{sum | formatMoney}}</div>
      </div>

      <div class="bill__field pt-2">
          <currency-input hide-details dense v-model="discount" label="Giảm giá"></currency-input>
      </div>

      <div class="bill__field pt-2">
        <div class="bill__label">Học viên Cần Trả:</div>
        <div class="bill__input font-weight-black">{{total | formatMoney}}</div>
      </div>

      <div class="bill__field pt-2">
          <currency-input hide-details dense v-model="paid" label="Học viên thanh toán"></currency-input>
      </div>

      <div class="bill__field pt-2">
        <div class="bill__label">Học viên Nợ:</div>
        <div class="bill__input font-weight-black">{{liabilities | formatMoney}}</div>
      </div >
          <v-select
          hide-details
            class="pt-2"
            label="Hình thức thanh toán"
            v-model="paymentType"
            :items="paymentTypes"
            dense
            outlined
            item-text="title"
            item-value="status"
          ></v-select>
      </div>
    <v-divider class="py-2"></v-divider>
    <div class='text-h6 font-weight-regular py-1'>Thông tin người nộp tiền</div>
    <div class="bill__block">
      <autocomplete-student
        hide-details
        class="py-1"
        v-model="student"
        label="Mã Học Viên"
        dense
        outlined
        return-object
        append-icon="search"
        @change="selectStudent"
      />
      <v-text-field hide-details v-model="customerName" outlined label="Họ Tên" required :rules="required" dense class="py-1"></v-text-field>
      <v-text-field hide-details v-model="customerPhone" outlined label="Số điện thoại" required :rules="required" dense class="py-1"></v-text-field>
      <v-textarea
        hide-details
        class="pt-2"
        outlined
        full-width
        no-resize
        required :rules="required"
        placeholder="Ghi chú"
        v-model="notes"
        dense
        :height="45"
      ></v-textarea>
    </div>
  </v-form>
</template>
<script>
import { mapState } from 'vuex'
import CurrencyInput from '@/components/basic/input/CurrencyInput.vue'
import utils from '@/plugins/utils.js'
import AutocompleteStudent from '@/components/basic/input/AutocompleteStudent.vue'
import _ from 'lodash'
export default {
  components: { CurrencyInput, AutocompleteStudent },
  props: {
    products: Array
  },
  data () {
    return {
      discount: '0',
      leadType: 'tuition',
      paid: '0',
      notes: '',
      date: new Date().toISOString(),
      student: null,
      customerName: '',
      tags: '',
      customerPhone: '',
      paymentType: 'cash',
      loading: false,
      required: [
        v => !!v || 'Truờng thông tin bắt buộc'
      ]
    }
  },
  created () {},
  computed: {
    ...mapState('constant', ['billStatus', 'paymentTypes', 'leadTypes']),
    sum () {
      return this.products.reduce(
        (acc, cur) => (acc += cur.price * cur.quantity),
        0
      )
    },
    total () {
      return this.sum - parseInt(this.discount)
    },
    liabilities () {
      return this.total - parseInt(this.paid)
    }
  },
  methods: {
    selectStudent (student) {
      this.student = student
      this.customerName = student.name
      this.customerPhone = student.phone
      this.customerName = student.name
    },
    validate () {
      console.log(this.$refs.form.validate())
      return this.$refs.form.validate()
    },
    reset () {
      this.student = null
      this.customerName = ''
      this.customerPhone = ''
      this.discount = ''
      this.paid = 0
      this.notes = ''
      this.date = new Date().toISOString()
      this.tags = ''
      this.paymentType = ''
    },
    getValues () {
      return {
        code: new Date().getTime() + '',
        notes: this.notes,
        status: this.liabilities > 0 ? 'liabilities' : 'paid',
        liabilities: this.liabilities,
        total: this.total,
        items: this.products,
        type: this.leadType,
        tags: this.tags,
        discount: parseInt(this.discount),
        sum: parseInt(this.sum),
        student: _.get(this.student, 'id'),
        state: _.get(this.student, 'id', false) ? 'approved' : 'under-approval',
        contact: _.get(this.contact, 'id'),
        paymentType: this.paymentType,
        customerPaid: parseInt(this.paid) || 0,
        provider: this.provider ? this.provider : 'direct-sale',
        customerName: this.customerName,
        customerPhone: this.customerPhone,
        date: this.date
      }
    }
  },
  filters: {
    formatMoney (amount) {
      return utils.formatMoney(amount)
    }
  },
  watch: {
    total (total) {
      this.paid = this.total
    },
    products () {
      this.notes = this.products.map(p => p.title).join(', ')
    }
  }
}
</script>
<style lang="scss" scoped>
.nowrap {
  white-space: nowrap;
}
.bill__form::v-deep {
  .v-data-table {
    td {
      padding-left: 0;
      border-bottom: none !important;
    }
  }
  tr:hover {
    background: none !important;
  }
  .bill__field {
    display: flex;
    align-items: center;
    .bill__label {
      flex-basis: 50%;
    }
    .bill__input {
      text-align: right;
      flex-basis: 50%;
    }
  }
  .v-autocomplete.v-select--is-menu-active .v-input__icon--append .v-icon {
    transform: none;
  }
  .bill__input .v-text-field__details {
    display: none!important;
  }
}
</style>
